export default __webpack_public_path__ + "static/portrait_anja-fb5e1f9da682cc22a8b0af8b96ba117c.jpg";